
import './App.css';

import { Box } from '@chakra-ui/react';

import AllRoutes from './Routes/AllRoutes';

function App() {
  return (
    <Box className='scroll' >
        <AllRoutes />
    </Box>
  );
}

export default App;
